import React, { useState } from "react";

const Offices = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    matter: "",
    message: "",
  });
  const [captchaChecked, setCaptchaChecked] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <section id="offices" className="bg-light-grey py-16 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-stretch">
          {/* Left Column */}
          <div className="lg:col-span-6 order-2 lg:order-1 flex">
            <div className="w-full rounded-3xl bg-[rgb(26,36,58)] p-6 sm:p-8 lg:p-10 text-white shadow-xl flex flex-col justify-between">
              <div>
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight">
                  Let’s discuss your{" "}
                  <span className="italic font-serif font-normal text-[#C9A04A]">
                    case
                  </span>
                </h3>

                {/* Nested White Form Card */}
                <div className="rounded-2xl bg-white p-6 sm:p-7 text-slate-800 shadow-md">
                  {submitted ? (
                    <div className="py-10 text-center">
                      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
                        <svg
                          className="h-6 w-6"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          strokeWidth={2.5}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <h4 className="text-lg font-bold text-emerald-900 mb-2">
                        Enquiry received!
                      </h4>
                      <p className="text-xs sm:text-sm text-emerald-700 max-w-sm mx-auto">
                        Thank you for reaching out. A specialist from Blackhorse Law will review your case and contact you shortly.
                      </p>
                      <button
                        type="button"
                        onClick={() => {
                          setSubmitted(false);
                          setFormData({
                            firstName: "",
                            lastName: "",
                            email: "",
                            phone: "",
                            matter: "",
                            message: "",
                          });
                          setCaptchaChecked(false);
                        }}
                        className="mt-5 text-xs font-semibold text-emerald-800 underline hover:opacity-80"
                      >
                        Submit another enquiry
                      </button>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} className="space-y-4">
                      {/* Name Fields */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                        <div>
                          <label className="block text-[11px] font-bold tracking-wider text-slate-500 uppercase mb-1">
                            First Name <span className="text-rose-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="firstName"
                            required
                            value={formData.firstName}
                            onChange={handleChange}
                            className="w-full rounded-lg border border-slate-200 px-3.5 py-2.5 text-sm text-slate-800 focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A] transition"
                          />
                        </div>
                        <div>
                          <label className="block text-[11px] font-bold tracking-wider text-slate-500 uppercase mb-1">
                            Last Name <span className="text-rose-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="lastName"
                            required
                            value={formData.lastName}
                            onChange={handleChange}
                            className="w-full rounded-lg border border-slate-200 px-3.5 py-2.5 text-sm text-slate-800 focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A] transition"
                          />
                        </div>
                      </div>

                      {/* Email and Phone */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                        <div>
                          <label className="block text-[11px] font-bold tracking-wider text-slate-500 uppercase mb-1">
                            Email <span className="text-rose-500">*</span>
                          </label>
                          <input
                            type="email"
                            name="email"
                            required
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full rounded-lg border border-slate-200 px-3.5 py-2.5 text-sm text-slate-800 focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A] transition"
                          />
                        </div>
                        <div>
                          <label className="block text-[11px] font-bold tracking-wider text-slate-500 uppercase mb-1">
                            Phone <span className="text-rose-500">*</span>
                          </label>
                          <div className="flex rounded-lg border border-slate-200 overflow-hidden focus-within:border-[#C9A04A] focus-within:ring-1 focus-within:ring-[#C9A04A] transition">
                            <div className="flex items-center gap-1 bg-slate-50 border-r border-slate-200 px-2.5 text-xs font-semibold text-slate-600">
                              <span>+44</span>
                              <span className="text-[10px] text-slate-400">UK</span>
                            </div>
                            <input
                              type="tel"
                              name="phone"
                              required
                              value={formData.phone}
                              onChange={handleChange}
                              placeholder="7123 456789"
                              className="w-full px-3 py-2 text-sm text-slate-800 focus:outline-none"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Matter Field */}
                      <div>
                        <label className="block text-[11px] font-bold tracking-wider text-slate-500 uppercase mb-1">
                          Immigration / Legal Matter
                        </label>
                        <input
                          type="text"
                          name="matter"
                          value={formData.matter}
                          onChange={handleChange}
                          placeholder="e.g. Skilled Worker visa, Spouse visa, Family law"
                          className="w-full rounded-lg border border-slate-200 px-3.5 py-2.5 text-sm text-slate-800 placeholder-slate-400 focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A] transition"
                        />
                      </div>

                      {/* Tell Us More */}
                      <div>
                        <label className="block text-[11px] font-bold tracking-wider text-slate-500 uppercase mb-1">
                          Tell Us More
                        </label>
                        <textarea
                          name="message"
                          rows={3}
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="Briefly describe your situation..."
                          className="w-full rounded-lg border border-slate-200 px-3.5 py-2.5 text-sm text-slate-800 placeholder-slate-400 focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A] transition"
                        />
                      </div>

                      {/* reCAPTCHA Box */}
                      <div className="flex items-center justify-between rounded-lg border border-slate-200 bg-slate-50/70 p-3">
                        <label className="flex items-center gap-3 cursor-pointer select-none">
                          <input
                            type="checkbox"
                            checked={captchaChecked}
                            onChange={(e) => setCaptchaChecked(e.target.checked)}
                            className="h-5 w-5 rounded border-slate-300 text-[#C9A04A] focus:ring-[#C9A04A] cursor-pointer"
                          />
                          <span className="text-xs sm:text-sm font-medium text-slate-700">
                            I'm not a robot
                          </span>
                        </label>
                        <div className="flex flex-col items-center justify-center pl-3">
                          <svg
                            className="w-6 h-6 text-blue-500"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                              fill="#4285F4"
                            />
                          </svg>
                          <span className="text-[9px] font-semibold text-slate-500 tracking-tight leading-tight">
                            reCAPTCHA
                          </span>
                          <span className="text-[8px] text-slate-400 leading-none">
                            Privacy · Terms
                          </span>
                        </div>
                      </div>

                      {/* Submit Button */}
                      <div className="pt-2">
                        <button
                          type="submit"
                          className="inline-flex items-center justify-center gap-2 rounded-full bg-[rgb(26,36,58)] hover:bg-[#C9A04A] text-white font-semibold text-sm px-6 py-3 transition duration-200 shadow-sm"
                        >
                          <span>Submit enquiry</span>
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M14 5l7 7m0 0l-7 7m7-7H3"
                            />
                          </svg>
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-6 order-1 lg:order-2 flex">
            <div className="w-full rounded-3xl bg-white p-8 sm:p-10 lg:p-12 shadow-panel border border-slate-100 flex flex-col justify-center">
              <h2 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-[rgb(26,36,58)] leading-tight mb-6">
                I need{" "}
                <span className="italic font-serif font-normal text-[#C9A04A]">
                  Solicitor?
                </span>{" "}
                Yes you Do
              </h2>

              <div className="space-y-4 text-slate-600 text-sm sm:text-base leading-relaxed text-justify">
                <p>
                  Immigration and family matters can involve important decisions with lasting consequences. Whether you are preparing an immigration application, facing a relationship breakdown or making arrangements for your children, understanding your options and the legal requirements can feel overwhelming. Professional legal advice can bring clarity, help you address potential difficulties and enable you to make informed decisions.
                </p>
                <p>
                  At Blackhorse Law, we recognise that every matter is personal. Your concerns may involve your future in the UK, your relationship with your children or your financial security following separation. We take the time to understand your circumstances and priorities, providing clear, practical advice with sensitivity and careful attention to detail.
                </p>
                <p>
                  Our immigration services can include preparing and submitting applications, advising on supporting evidence, drafting legal representations and communicating with the Home Office on your behalf. In family matters, we can advise on divorce and separation, child arrangements and financial matters arising from relationship breakdown, helping you pursue practical solutions and providing representation where agreed.
                </p>
                <p>
                  From the outset, we explain the scope of our work, the steps involved and the associated fees. Throughout your matter, we keep you informed so that you understand your position and what happens next.
                </p>
                <p>
                  Whether you are bringing your family together, planning your future or navigating a difficult change in your personal life, Blackhorse Law offers professional advice and attentive support tailored to you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offices;
